import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { useNavigate } from 'react-router-dom';
import { API_BASE } from '../config';
import '../styles/contenedor.css';

const Contenedor = () => {
  const { token } = useAuth();
  const navigate = useNavigate();
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [downloadingExample, setDownloadingExample] = useState(false);
  const [result, setResult] = useState(null);
  const [error, setError] = useState(null);

  const handleFileChange = (event) => {
    setFile(event.target.files[0]);
    setResult(null);
    setError(null);
  };

  const handleDownloadExample = async () => {
    setDownloadingExample(true);
    setError(null);
    try {
      const response = await fetch(`${API_BASE}/contenedor/example/`, {
        method: 'GET',
        headers: { 'Authorization': `Token ${token}` },
      });
      if (!response.ok) {
        setError('No se pudo descargar el archivo de ejemplo.');
        return;
      }
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'contenedor_ejemplo.xlsx';
      document.body.appendChild(a);
      a.click();
      document.body.removeChild(a);
      window.URL.revokeObjectURL(url);
    } catch (err) {
      setError('Error de conexión al servidor.');
    } finally {
      setDownloadingExample(false);
    }
  };

  const handleSubmit = async (event) => {
    event.preventDefault();

    if (!file) {
      setError('Por favor, selecciona un archivo.');
      return;
    }

    setLoading(true);
    setError(null);
    setResult(null);

    const formData = new FormData();
    formData.append('file', file);

    try {
      const response = await fetch(`${API_BASE}/contenedor/upload/`, {
        method: 'POST',
        headers: {
          'Authorization': `Token ${token}`,
        },
        body: formData,
      });

      const data = await response.json();

      if (!response.ok) {
        setError(data.error || 'Error al procesar el archivo.');
        return;
      }

      setResult(data);
      setFile(null);
      const fileInput = document.querySelector('.contenedor-file-input');
      if (fileInput) fileInput.value = '';
    } catch (err) {
      setError('Error de conexión al servidor.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="contenedor-page">
      <button className="contenedor-back-button" onClick={() => navigate('/init')}>
        &#8592;
      </button>
      <div className="contenedor-container">
        <h1 className="contenedor-title">Contenedor</h1>
        <p className="contenedor-subtitle">
          Carga masiva de stock desde un archivo Excel.
        </p>

        <form onSubmit={handleSubmit} className="contenedor-form">
          <label className="contenedor-label">Archivo Excel (.xls / .xlsx)</label>
          <input
            type="file"
            onChange={handleFileChange}
            accept=".xls,.xlsx"
            className="contenedor-file-input"
          />
          <p className="contenedor-hint">
            Columnas requeridas: SKU, Cantidad, Rack, Shelf, Fecha de vencimiento (ddmmyyyy).
          </p>

          <button
            type="button"
            className="contenedor-example-button"
            onClick={handleDownloadExample}
            disabled={downloadingExample}
          >
            {downloadingExample ? 'Descargando...' : 'Descargar archivo de ejemplo'}
          </button>

          {error && <div className="contenedor-error">{error}</div>}

          <button type="submit" className="contenedor-submit-button" disabled={loading}>
            {loading ? 'Procesando...' : 'Subir Contenedor'}
          </button>
        </form>

        {result && (
          <div className="contenedor-result">
            <div className="contenedor-result-summary">
              <span className="contenedor-success-count">{result.success_count} exitosos</span>
              {result.error_count > 0 && (
                <span className="contenedor-error-count">{result.error_count} errores</span>
              )}
            </div>
            {result.errors && result.errors.length > 0 && (
              <div className="contenedor-errors-list">
                <h3>Errores:</h3>
                {result.errors.map((err, idx) => (
                  <div key={idx} className="contenedor-error-item">
                    Fila {err.row} - SKU: {err.sku} - {err.error}
                  </div>
                ))}
              </div>
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Contenedor;
